import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type Gtag = (...args: unknown[]) => void;

// 구글 애널리틱스(GA4) 페이지 조회 기록.
// 첫 진입은 index.html 의 gtag('config') 가 기록하고, 이후 사이트 안에서 메뉴 · 링크로 이동할 때(새로고침 없는 이동)는
// 여기서 page_view 를 보냅니다. (2026-10-18 점검: 사이트 안 이동이 집계되지 않던 문제 수정)
// 같은 페이지 안의 #이동(예: /#contact)은 페이지 조회로 세지 않습니다.
export default function Analytics() {
  const { pathname, search } = useLocation();
  const prevUrl = useRef<string | null>(null);

  useEffect(() => {
    const url = window.location.origin + pathname + search;
    const referrer = prevUrl.current;
    prevUrl.current = url;
    if (referrer === null || referrer === url) return; // 첫 진입(이미 기록됨) · 같은 주소
    // 새 페이지의 제목이 반영된 뒤 기록되도록 이번 화면 갱신이 끝난 다음에 보냄
    const id = window.setTimeout(() => {
      const gtag = (window as Window & { gtag?: Gtag }).gtag;
      gtag?.("event", "page_view", { page_location: url, page_title: document.title, page_referrer: referrer });
    }, 0);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
}
